import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { ClockIcon, ExclamationTriangleIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

const TokenStatus = () => {
  const { user, checkTokenValidity } = useAuth();
  const [lastChecked, setLastChecked] = useState(null);
  const [isChecking, setIsChecking] = useState(false);

  const handleManualCheck = async () => {
    if (isChecking) return; // Prevent multiple simultaneous checks
    
    setIsChecking(true);
    try {
      await checkTokenValidity();
      setLastChecked(new Date());
    } catch (error) {
      console.error('Token check failed:', error);
    } finally {
      setIsChecking(false);
    }
  };

  useEffect(() => {
    if (user) {
      setLastChecked(new Date());
    }
  }, [user]);

  if (!user) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg shadow p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="flex items-center space-x-2">
            <CheckCircleIcon className="h-5 w-5 text-green-500" />
            <span className="text-sm font-medium text-gray-700">Authentication Status</span>
          </div>
          <div className="text-sm text-gray-500">
            Logged in as: <span className="font-medium">{user.username}</span>
          </div>
        </div>
        
        <div className="flex items-center space-x-4">
          {lastChecked && (
            <div className="text-xs text-gray-500 flex items-center space-x-1">
              <ClockIcon className="h-4 w-4" />
              <span>Last checked: {lastChecked.toLocaleTimeString()}</span>
            </div>
          )}
          
          <button
            onClick={handleManualCheck}
            disabled={isChecking}
            className="inline-flex items-center px-3 py-1 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50"
          >
            {isChecking ? 'Checking...' : 'Check Token'}
          </button>
        </div>
      </div>
      
      <div className="mt-3 text-xs text-gray-600">
        <div className="flex items-center space-x-1">
          <ExclamationTriangleIcon className="h-4 w-4 text-yellow-500" />
          <span>Token expires after 1 hour. You'll be automatically logged out when it expires.</span>
        </div>
      </div>
    </div>
  );
};

export default TokenStatus;
